import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import { useNavigate } from "react-router-dom";
import AssignPopup from "../components/AssignPopup";
import { 
  useRequestApplications,
  useAssignApplication,
  useTLUsers
} from "../../hooks/useApplications";
//import api from "../../services/api";

const Dashboard = () => {
  const navigate = useNavigate();
  const [showAssignPopup, setShowAssignPopup] = useState(false);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [userDesignation, setUserDesignation] = useState('Manager');
  
  // React Query hooks
  const { data: dashboardData = [], isLoading } = useRequestApplications();
  const { data: tlUsers = [] } = useTLUsers();
  const assignApplicationMutation = useAssignApplication();
  
  // Get user designation from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUserDesignation(userData.designation || 'Manager');
      } catch (error) {
        console.error('Error parsing user data:', error);
        setUserDesignation('Manager');
      }
    }
  }, []);


  // Function to format date (Req. Date as today's date)
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB");
  };

  // const navigatToResturantApproval = () => {
  //   navigate("/BOD/restaurants-approvals");
  // };

  const handleAssignClick = (restaurant) => {
    setSelectedRestaurant(restaurant);
    setShowAssignPopup(true);
  };

  const handleAssign = (userId, action) => {
    if (action === 'assign' && selectedRestaurant && userId) {
      assignApplicationMutation.mutate({ applicationId: selectedRestaurant._id, tlId: userId });
    }
    setShowAssignPopup(false);
    setSelectedRestaurant(null);
  };
  return (
    <div className="dashboard-container">
      <div className="content">
        <h1 className="dashboard-title">Dashboard</h1>
        <div className="stats">
          <div className="stat-card">
            <p>Total Sales</p>
            <h2>1750</h2>
          </div>
          <div className="stat-card">
            <p>Active Users</p>
            <h2>56</h2>
          </div>
          <div className="stat-card">
            <p>Pending Approvals</p>
            <h2>43</h2>
          </div>
          <div className="stat-card">
            <p>New Approval Req</p>
            <h2>05</h2>
          </div>
        </div>

        <table className="dashboard-table">
          <thead>
            <tr>
              <th>Case No.</th>
              <th>Restaurant Name</th>
              <th>Location</th>
              <th>Req. Date</th>
              <th>Status</th>
              <th>Documents</th>
              <th>Total Amt.</th>
              <th>Payment</th>
              <th>Assign</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="9" style={{textAlign: 'center', padding: '20px'}}>Loading...</td>
              </tr>
            ) : dashboardData.length > 0 ? (
              dashboardData.map((application) => {
                const restaurant = application.restaurantId || {};
                const address = restaurant.restaurantAddress || {};
                return (
                  <tr key={application._id}>
                    <td>#{restaurant.caseNumber || restaurant._id}</td>
                    <td>{restaurant.restaurantName || 'N/A'}</td>
                    <td>{address.city || 'N/A'}</td>
                    <td>{formatDate(application.createdAt)}</td>
                    <td>
                      <span className="status pending">{application.currentStage || 'Pending'}</span>
                    </td>
                    <td>{restaurant.documentCount || 4}</td>
                    <td>{restaurant.totalAmount || 0}</td>
                    <td>{application.paymentStatus || 'Pending'}</td>
                    <td>
                      <button
                        className="view-btn"
                        onClick={() => handleAssignClick(application)}>
                        Assign
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="9" style={{textAlign: 'center', padding: '20px'}}>No applications found</td>
              </tr>
            )}
          </tbody>
        </table>
        
        <AssignPopup
          isOpen={showAssignPopup}
          onClose={() => setShowAssignPopup(false)}
          onAssign={handleAssign}
          tlUsers={tlUsers}
          userDesignation={userDesignation}
        />
      </div>
    </div>
  );
};

export default Dashboard;
